import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import DateTimeDisplay from "./DateTimeDisplay";

//Hooks
import { useCountdown } from "../../hooks/useCountDown";

//Styles Rules
import { Colors } from "../../styles";

const CountDownTimer = ({ date = "08/19/2022", title }) => {
	const { days, hours, minutes } = useCountdown(date); // mm/dd/yyyy

	const renderCounter =
		days + hours + minutes <= 0 ? (
			<CounterOverMsg>The CNE is happening right now</CounterOverMsg>
		) : (
			<Row>
				<DateTimeDisplay time={days} type={days > 1 ? "days" : "day"} />
				<DateTimeDisplay time={hours} type={"hours"} />
				<DateTimeDisplay time={minutes} type={"minutes"} />
			</Row>
		);

	return (
		<CounterWrapper>
			{title && <CounterTitle>{title}</CounterTitle>}
			{renderCounter}
		</CounterWrapper>
	);
};
CountDownTimer.propTypes = {
	date: PropTypes.any,
	title: PropTypes.string,
};

export default CountDownTimer;

const CounterWrapper = styled.div`
	padding-top: 5rem;
	* {
		color: ${Colors.base.white};
	}
`;

const CounterTitle = styled.h3`
	font-size: 1.6rem;
	line-height: 2.6rem;
	text-transform: none;
`;

const CounterOverMsg = styled.p`
	text-transform: none;
	padding-top: 0.9rem;
	font-size: 1.6rem;
	line-height: 2.6rem;
	letter-spacing: -0.0015em;
`;

const Row = styled.div`
	padding-top: 1.4rem;
	display: flex;
	gap: 4rem;
`;
